var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"calc(100% - 2px)"}},[_c('iframe',{staticClass:"w-full h-full",attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }